module.exports = __webpack_public_path__ + "img/step_phone2.10b71b15.png";